module.exports = __webpack_public_path__ + "img/vector_top.09e309e2.svg";